module.exports = __webpack_public_path__ + "static/homebannerbg-d8e30952f86f04e5f8956e2dab2bbc4f.jpg";